import { observer } from "mobx-react";
import React, { FC } from "react";
import { PurchaseStore } from "../store";
import {
  CheckoutColorType,
  CheckOutHelpType,
  UpsertPurchaseActiveStep,
} from "../enums";
import { CheckoutBrandingModel, SellerModel } from "../models";
import {
  CustomLabel,
  FlexContainer,
  NavHorizontalBar,
  withRouter,
} from "@mindmemobile/mm-shared-global";
type IProps = {
  purchaseStore: PurchaseStore;
  onTabChange: (key: UpsertPurchaseActiveStep) => void;
  brandingData: CheckoutBrandingModel;
  showLogo: boolean;
  showHelp: boolean;
  activeStep?: UpsertPurchaseActiveStep;
  hideProgressBar?: boolean;
  seller: SellerModel;
  isDonationOnly?: boolean;
};

const PurchaseTopBar: FC<IProps> = ({
  purchaseStore,
  onTabChange,
  brandingData,
  showHelp,
  showLogo,
  activeStep,
  hideProgressBar = false,
  seller,
  isDonationOnly = false,
}) => {
  const getStepStyle = (step: UpsertPurchaseActiveStep) => {
    if (!brandingData) return "";
    if (isDonationOnly && brandingData.donationCheckout) {
      return activeStep === step
        ? brandingData.donationCheckout.mainColors[0].color?.rgba ||
            "rgba(44, 62, 80)"
        : "#DDDDDD";
    }
    switch (brandingData.selectedColorType) {
      case CheckoutColorType.BasicColor:
        return activeStep === step ? "#68C598" : "#DDDDDD"; //changes made here
      // return activeStep === step
      //   ? brandingData.basicColors.getBasicColors().selectedBar.rgba
      //   : brandingData.basicColors.getBasicColors().unSelectedBar.rgba; //Prasanna please pass colors here
      case CheckoutColorType.CustomColor:
        return activeStep === step
          ? brandingData.customColors.getCustomColors().selectedBar.rgba
          : brandingData.customColors.getCustomColors().unSelectedBar.rgba;
    }
  };

  const isProduct =
    purchaseStore.checkOutPurchaseDetails?.item.itemType === "Product";
  const hasVariants = purchaseStore.checkOutPurchaseDetails?.item.hasVariants;

  const handleStepClick = (step: UpsertPurchaseActiveStep) => {
    onTabChange(step);
  };
  // const colors = purchaseStore.getColors();

  function helpEmailOrPhone() {
    if (!brandingData?.showHelp) return null;

    return (
      <FlexContainer
        justifyContent="flex-end"
        className="purchase-helpline-container"
      >
        <CustomLabel textAlign="right" className="purchase-helpline">
          {brandingData.sellerContact === CheckOutHelpType.Phone
            ? "Call for Help"
            : "Email for Help"}
          <br />
          {brandingData.sellerContact === CheckOutHelpType.Phone
            ? `${brandingData.phoneNumber}`
            : `${brandingData.helpEmail}`}
        </CustomLabel>
      </FlexContainer>
    );
  }

  return (
    <>
      <FlexContainer
        justifyContent="space-between"
        alignItems="center"
        className={`purchase-nav-flex`}
      >
        <div className={`purchase-profile`}>
          {showLogo && seller?.logoURL && (
            <FlexContainer>
              <img
                // src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxljCiU3pRUXpw-39aklTNk7BDV3G9Dn7ocw&s"
                src={seller.logoURL}
                alt="logo"
              />
              <CustomLabel>{seller.name}</CustomLabel>
            </FlexContainer>
          )}
        </div>
        {!hideProgressBar && (
          <div className="purchase-steps">
            <FlexContainer>
              {Object.keys(UpsertPurchaseActiveStep).map((key) => {
                const step = key as UpsertPurchaseActiveStep;
                if (
                  UpsertPurchaseActiveStep[step] ===
                  UpsertPurchaseActiveStep.AddOn
                ) {
                  if (!purchaseStore.showCheckOutAddOns()) {
                    return null;
                  }
                }
                if (
                  UpsertPurchaseActiveStep[step] ===
                  UpsertPurchaseActiveStep.Options
                ) {
                  const hasAddOnsForDonation =
                    purchaseStore.checkOutPurchaseDetails &&
                    purchaseStore.checkOutPurchaseDetails?.addOns?.length > 0;
                  if (
                    purchaseStore.customerFacingCheckOutDetails
                      .isDonationOnly &&
                    !hasAddOnsForDonation
                  ) {
                    return null;
                  }
                  if (!hasVariants && !purchaseStore.showCheckOutAddOns()) {
                    return null;
                  }
                }
                if (step === UpsertPurchaseActiveStep.Success) return null;

                return (
                  <div key={key}>
                    <FlexContainer
                      alignItems="center"
                      spacing={10}
                      onClick={() => handleStepClick(step)}
                    >
                      <NavHorizontalBar
                        bgColor={getStepStyle(key as UpsertPurchaseActiveStep)}
                      />
                    </FlexContainer>
                  </div>
                );
              })}
            </FlexContainer>
          </div>
        )}
        <div>{showHelp && helpEmailOrPhone()}</div>
      </FlexContainer>

      <div
        className={`purchase-steps-subtopbar ${showHelp ? "topbar-with-margin" : ""}`}
      >
        <FlexContainer spacing={10} justifyContent="center">
          {Object.keys(UpsertPurchaseActiveStep).map((key) => {
            const step = key as UpsertPurchaseActiveStep;
            if (
              UpsertPurchaseActiveStep[step] === UpsertPurchaseActiveStep.AddOn
            ) {
              if (!purchaseStore.showCheckOutAddOns()) {
                return null;
              }
            }
            if (
              UpsertPurchaseActiveStep[step] ===
              UpsertPurchaseActiveStep.Options
            ) {
              const hasAddOnsForDonation =
                purchaseStore.checkOutPurchaseDetails &&
                purchaseStore.checkOutPurchaseDetails?.addOns?.length > 0;
              if (
                purchaseStore.customerFacingCheckOutDetails.isDonationOnly &&
                !hasAddOnsForDonation
              ) {
                return null;
              }
              if (!hasVariants && !purchaseStore.showCheckOutAddOns()) {
                return null;
              }
            }

            if (step === UpsertPurchaseActiveStep.Success) return null;

            return (
              <div key={key} onClick={() => handleStepClick(step)}>
                <NavHorizontalBar
                  bgColor={getStepStyle(key as UpsertPurchaseActiveStep)}
                />
              </div>
            );
          })}
        </FlexContainer>
      </div>
    </>
  );
};

export default withRouter(observer(PurchaseTopBar));
